var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20.667,
    height: 20.666,
    viewBox: "0 0 20.667 20.666",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(-42.167 -94.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 9.042,
    height: 9.042,
    rx: 1.5,
    transform: "translate(42.167 94.167)",
    fill: "#b5b5c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M50.792,121.667a1.5,1.5,0,0,1,1.5-1.5h6.042a1.5,1.5,0,0,1,1.5,1.5v6.041a1.5,1.5,0,0,1-1.5,1.5H52.292a1.5,1.5,0,0,1-1.5-1.5ZM39.167,133.292a1.5,1.5,0,0,1,1.5-1.5h6.042a1.5,1.5,0,0,1,1.5,1.5v6.041a1.5,1.5,0,0,1-1.5,1.5H40.667a1.5,1.5,0,0,1-1.5-1.5Zm13.125-1.5a1.5,1.5,0,0,0-1.5,1.5v6.041a1.5,1.5,0,0,0,1.5,1.5h6.042a1.5,1.5,0,0,0,1.5-1.5v-6.041a1.5,1.5,0,0,0-1.5-1.5Z",
    transform: "translate(3 -26)",
    fill: "#b5b5c3",
    fillRule: "evenodd",
    opacity: 0.28
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.8ff5c6df.svg";
export { ForwardRef as ReactComponent };